import React, { createContext, useContext } from 'react';
import { MessageTracking } from '@99designs/messaging';

interface FileOverlayTrackingContextValue {
    annotationSentTracking?: MessageTracking;
}
interface FileOverlayTrackingContextProviderProps {
    annotationSentTracking?: MessageTracking;
    children: React.ReactNode;
}

const context = createContext<FileOverlayTrackingContextValue | null>(null);

export function FileOverlayTrackingProvider(props: FileOverlayTrackingContextProviderProps) {
    const { children, annotationSentTracking } = props;

    return <context.Provider value={{ annotationSentTracking }}>{children}</context.Provider>;
}

export function useFileOverlayTracking(): FileOverlayTrackingContextValue {
    const value = useContext(context);

    if (!value) {
        throw new Error('useFileOverlayTracking must be used within a FileOverlayTrackingProvider');
    }

    return value;
}
